import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from "react";
const ThemeContext = createContext({
    theme: "light",
    toggleTheme: () => { }
});
export default ThemeContext;
export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        const stored = localStorage.getItem("hgu-theme");
        if (stored === "dark" || stored === "light")
            return stored;
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("hgu-theme", theme);
    }, [theme]);
    function toggleTheme() {
        setTheme((t) => (t === "light" ? "dark" : "light"));
    }
    return (_jsx(ThemeContext.Provider, { value: { theme, toggleTheme }, children: children }));
}
